import jwtUtil from '../../utils/jwtUtil'

export default {
    state: {
        token: localStorage.getItem('commercial-cms-api-token') === 'null' ? null : localStorage.getItem('commercial-cms-api-token'),
        drawer: localStorage.getItem('drawer') === 'null' ? false : localStorage.getItem('drawer') === 'true',
        refreshToken: localStorage.getItem('commercial-cms-refreshToken'),
        refreshTokenExpiration: localStorage.getItem('commercial-cms-refreshTokenExpiration'),
        tableStates: {}
    },
    mutations: {
        setToken(state, value) {
            state.token = value
        },
        setDrawer(state, value) {
            state.drawer = value
        },
        setRefreshToken(state, value) {
            state.refreshToken = value
        },
        setRefreshTokenExpiration(state, value) {
            state.refreshTokenExpiration = value
        },
        setTableState(state, { table, value }) {
            state.tableStates = { ...state.tableStates, [table]: value }
        },
        clearTableStates(state) {
            state.tableStates = {}
        }
    },
    actions: {
        logout({ commit, dispatch }) {
            dispatch('setToken', null)
            dispatch('setDrawer', null)
            dispatch('setRefreshToken', null)
            dispatch('setRefreshTokenExpiration', null)
            commit('clearTableStates')
        },
        login({ dispatch }, [resp]) {
            if (resp.data.token) {
                dispatch('setToken', resp.data.token)
                dispatch('setDrawer', false)
                dispatch('setRefreshToken', resp.data.refreshToken)
                dispatch('setRefreshTokenExpiration', resp.data.refreshTokenExpiration)
            }
        },
        setTableState({ commit }, { table, value }) {
            commit('setTableState', { table, value })
        },
        setToken({ commit }, token) {
            localStorage.setItem('commercial-cms-api-token', token)
            commit('setToken', token)
        },
        setDrawer({ commit }, drawer) {
            localStorage.setItem('drawer', drawer)
            commit('setDrawer', drawer)
        },
        setRefreshToken({ commit }, refreshToken) {
            if (refreshToken) {
                localStorage.setItem('commercial-cms-refreshToken', refreshToken)
                commit('setRefreshToken', refreshToken)
            } else {
                localStorage.removeItem('refreshToken')
                commit('setRefreshToken', null)
            }
        },
        setRefreshTokenExpiration({ commit }, refreshTokenExpiration) {
            if (refreshTokenExpiration) {
                localStorage.setItem('commercial-cms-refreshTokenExpiration', refreshTokenExpiration)
                commit('setRefreshTokenExpiration', refreshTokenExpiration)
            } else {
                localStorage.removeItem('commercial-cms-refreshTokenExpiration')
                commit('setRefreshTokenExpiration', null)
            }
        }
    },
    getters: {
        getToken: state => state.token,
        isLoggedIn(state) {
            // is string null because of local storage
            return state.token !== null
        },
        getDrawer: state => state.drawer,
        getRefreshToken: state => state.refreshToken,
        getRefreshTokenExpiration: state => state.refreshTokenExpiration,
        getTableState: state => table => state.tableStates[table] || null,
        // Return the first role found in the JWT (string) or null
        getUserRole: state => jwtUtil.getRole(state.token),
        // Return an array of roles or null
        getUserRoles: state => jwtUtil.getRoles(state.token),
        // amounts (payments, revenue, costs) are shown to admins only
        isAdmin: state => (jwtUtil.getRoles(state.token) || []).includes('ROLE_ADMIN')
    }
}
